import { LINK_DEV } from 'constants/index';
import { clearCookies } from 'functions';
import Utils from 'utils';

export const homepage = window.location.origin;

export const httpStatus = {
  success: 200,
  error: 412,
  exception: 420,
  notFound: 404,
  upgradeRequired: 426,
  badRequest: 400,
  unauthorized: 401,
};

export const httpTextStatus = {
  success: 'success',
  fail: 'fail',
  error: 'error',
};

export const backGroud = [homepage + '/assets/images/carousel/pc/backgroud3.PNG'];

export const imgBVNTs = [
  homepage + '/assets/images/carousel/pc/BVNTCard.png',
  homepage + '/assets/images/carousel/pc/BVNTImger.PNG',
];

export const imgLogoBv = [homepage + '/assets/images/loyalty/pc/logoBv.jpg'];

export const imgLogoUrbox = [homepage + '/assets/images/loyalty/pc/logoUrbox.PNG'];

export const imgVouchers = [
  homepage + '/assets/images/carousel/pc/Voucher1xs.PNG',
  homepage + '/assets/images/carousel/pc/Voucher2.PNG',
];

export const appCodes = {
  EPOS: 'EPOS',
  MRP: 'MRP',
};

export const imgbuttonGift = [homepage + '/assets/images/loyalty/pc/buttonGift.png'];

export const imgBVNTDiamond = [homepage + '/assets/images/loyalty/pc/DiamondImg.jpg'];

export const imgBVNTGold = [homepage + '/assets/images/loyalty/pc/GoldImg.jpg'];

export const imgBVNTPlatinum = [homepage + '/assets/images/loyalty/pc/PlatinumImg.jpg'];

export const imgBVNTPremierHSBC = [homepage + '/assets/images/loyalty/pc/PremierHSBC.jpg'];

export const imgBVNTPremierHSBCsmall = [homepage + '/assets/images/loyalty/smp/PremierHSBC.jpg'];

export const imgBVNTSilverPlus = [homepage + '/assets/images/loyalty/pc/silver.jpg'];

export const handleAccountInfo = () => {
  window.location.href = '';
};

export const handleLogout = () => {
  console.log('run...');
  clearCookies();
};
const handleUpdateAccount = () => {
  window.location.href = '/pages/update-account-info';
};

export const linkUserItems = [
  {
    icon: 'fa fa-user-o',
    iconColor: 'default',
    name: 'Thông tin tài khoản',
    function: handleAccountInfo,
  },
  {
    icon: 'sli-settings',
    iconColor: 'default',
    name: 'Cập nhật tài khoản',
    function: handleUpdateAccount,
  },
  {
    icon: 'sli-power',
    iconColor: 'default',
    name: 'Đăng xuất',
    function: () => {
      handleLogout();
      // window.location.href = `${LINK_DEV}/?logout`;
    },
  },
];

export const objPendingErrorFalse = {
  pending: false,
  error: false,
};
